import React, { Component } from 'react';
import { FieldGroup, FieldControl, Validators, FormBuilder } from 'react-reactive-form';
import { readableResponseMessage, scroller } from 'ux-helpers';
import { getActualStartDate, getActualEndDate } from './../../../helpers/TripHelper';
import PropTypes from 'proptypes';
import { Auth, API, Storage } from 'aws-amplify';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from 'react-modal';
import InsurancePreviewModal from './previewModals/InsurancePreviewModal';

export default class Insurance extends Component {
  state = {
    insuranceDoc: this.props.insurance ? this.props.insurance : {},
    insStartDate:
      this.props.insurance && this.props.insurance.insStartDate
        ? moment(this.props.insurance.insStartDate)
        : moment(),
    insEndDate:
      this.props.insurance && this.props.insurance.insEndDate
        ? moment(this.props.insurance.insEndDate)
        : moment(),
    trip: this.props.trip ? this.props.trip : {},
  };

  componentDidMount() {
    const insStartDateInput = document.getElementById('insStartDate');

    if (insStartDateInput !== null) {
      insStartDateInput.readOnly = true;
    }

    const insEndDateInput = document.getElementById('insEndDate');

    if (insEndDateInput !== null) {
      insEndDateInput.readOnly = true;
    }

    let uploadField;

    if (document.getElementById('initial-ins-upload-field') !== null) {
      uploadField = document.getElementById('initial-ins-upload-field');
    } else {
      uploadField = document.getElementById('update-ins-upload-field');
    }

    uploadField.onchange = () => {
      if (uploadField.files[0].size > 2000000) {
        this.setState({
          successOrErrorMessage: false,
          message: 'File size exceeds 2mb. Please choose a smaller file.',
        });
        uploadField.value = '';
      } else {
        this.setState({
          message: '',
        });
      }
    };
  }

  onImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () =>
          this.setState({
            travelDocument: reader.result,
          }),
        false
      );
      reader.readAsDataURL(e.target.files[0]);
      this.insuranceForm.controls.travelDocument.setValue(e.target.files[0]);
      this.setState({
        travelDocumentFileName: e.target.files[0].name,
      });
    }
  };

  uploadDocument = document => {
    const fileName = document.name;
    const fileType = document.type;
    Storage.put(fileName, document, {
      level: 'protected',
      contentType: fileType,
    }).catch(error => {
      this.setState({
        message: 'Whoops! Looks like we had a problem uploading your file.',
      });
    });
  };

  returnFileNameAndType = () => {
    const url = this.state.insuranceDoc.travelDocumentURL;
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return {
      key: url,
      type: extension,
    };
  };

  openModal = modalName => {
    let fileAttributes = this.returnFileNameAndType();
    Storage.get(fileAttributes.key, { level: 'protected' })
      .then(result => {
        if (
          fileAttributes.type === 'pdf' ||
          fileAttributes.type === 'doc' ||
          fileAttributes.type === 'docx'
        ) {
          window.open(result);
        } else {
          this.setState({
            previewUrl: result,
            activeModal: modalName,
          });
        }
      })
      .catch(() => {});
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.insuranceForm.status === 'VALID') {
      this.setState({ loadingBtn: true });
      this.insuranceForm.handleSubmit();
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: this.insuranceForm.value,
        };
        options.body.userId = this.props.userId;
        options.body.userName = user.idToken.payload.nickname;
        options.body.travelDocument = this.state.travelDocument;
        options.body.fileName = this.state.travelDocumentFileName;
        this.uploadDocument(this.insuranceForm.controls.travelDocument.value);
        API.post('give-api', `/documents/${this.props.tripId}/insurance/`, options)
          .then(response => {
            this.setState({
              successOrErrorMessage: true,
              loadingBtn: false,
              message: response.Message,
              insuranceDoc: {
                insProvider: response.Data.Ins_Provider__c,
                insPolicy: response.Data.Ins_Policy__c,
                insStartDate: response.Data.Ins_Start_Date__c,
                insEndDate: response.Data.Ins_End_Date__c,
                travelDocumentURL: response.Data.travelDocumentUrl
                  ? response.Data.travelDocumentUrl
                  : this.state.insuranceDoc.travelDocumentURL,
              },
            });
            this.insuranceForm.handleSubmit();
            this.props.setDocumentsAccordionState('insurance');
            this.setState({ travelDocument: '' });
            this.props.deactiveActiveAccordion('insurance-widget');
            scroller('insProvider');
            setTimeout(() => {
              this.setState({ message: '' });
            }, 3000);
          })
          .catch(error => {
            this.setState({
              successOrErrorMessage: false,
              loadingBtn: false,
              message: readableResponseMessage(error),
            });
            this.insuranceForm.handleSubmit();
            scroller('insProvider');
          });
      });
    } else {
      this.insuranceForm.handleSubmit();
    }
  };

  handleStartDateChange = date => {
    const formattedDate = moment(date).format();
    this.insuranceForm.controls.insStartDate.setValue(formattedDate);
    this.setState({
      insStartDate: date,
    });
  };

  handleEndDateChange = date => {
    const formattedDate = moment(date).format();
    this.insuranceForm.controls.insEndDate.setValue(formattedDate);
    this.setState({
      insEndDate: date,
    });
  };

  validateStartDate = control => {
    const startDate = getActualStartDate(this.props.trip.startDate, this.props.trip.currentAddOns);

    if (
      moment(moment(control.value).format('L')) > moment(moment(startDate).format('L')) &&
      moment(moment(control.value).format('L')) !== moment(moment(startDate).format('L'))
    ) {
      return { invalidDate: true };
    }
  };

  validateEndDate = control => {
    const endDate = getActualEndDate(this.props.trip.endDate, this.props.trip.currentAddOns);
    if (
      moment(moment(control.value).format('L')) < moment(moment(endDate).format('L')) &&
      moment(moment(control.value).format('L')) !== moment(moment(endDate).format('L'))
    ) {
      return { invalidDate: true };
    }
  };

  insuranceForm = FormBuilder.group({
    insProvider: [
      this.state.insuranceDoc && this.state.insuranceDoc.insProvider
        ? this.state.insuranceDoc.insProvider
        : '',
      [Validators.required, Validators.maxLength(50)],
    ],
    insPolicy: [
      this.state.insuranceDoc && this.state.insuranceDoc.insPolicy
        ? this.state.insuranceDoc.insPolicy
        : '',
      [Validators.required, Validators.maxLength(50)],
    ],
    insStartDate: [
      this.state.insStartDate ? this.state.insStartDate : '',
      [Validators.required, this.validateStartDate],
    ],
    insEndDate: [
      this.state.insEndDate ? this.state.insEndDate : '',
      [Validators.required, this.validateEndDate],
    ],
    travelDocument: [
      this.state.insuranceDoc && this.state.insuranceDoc.travelDocumentURL
        ? this.state.insuranceDoc.travelDocumentURL
        : '',
      Validators.required,
    ],
  });

  render() {
    return (
      <div>
        {this.state.insuranceDoc.reasonDeclined ? (
          <div className="col-md-12 warning-text-container">
            <p className="warning-color">{this.state.insuranceDoc.reasonDeclined}</p>
          </div>
        ) : (
          ''
        )}
        <p>
          <span className="round-icon small">1</span> Purchase{' '}
          <a
            href={`${
              this.props.mailingCountry === 'United States'
                ? 'https://go.givevolunteers.org/getinsurance'
                : 'https://go.givevolunteers.org/getinsurance2'
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Travelers Insurance.
          </a>{' '}
          This is required and different from health insurance - it includes covered benefits for
          trip cancellation/interruption, flight and baggage delays, emergency medical assistance,
          and more. Make sure to cover your trip and flight costs. For additional information{' '}
          <button className="btn-plain-text" onClick={this.props.openModal}>
            click here.
          </button>
        </p>

        <p>
          <span className="round-icon small">2</span> Input Insurance Provider, policy number, and
          coverage details.
        </p>
        {this.state.message ? (
          <p
            id="error"
            className={`center ${this.state.successOrErrorMessage === true ? 'success' : 'error'}`}
          >
            {this.state.message}
          </p>
        ) : (
          ''
        )}
        <FieldGroup
          control={this.insuranceForm}
          render={({ value, submitted }) => (
            <form
              name="Insurance"
              id="insurance-form"
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              <div>
                <FieldControl
                  name="insProvider"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input id="insProvider" className="form-control" type="text" {...handler()} />
                      <label
                        htmlFor="insProvider"
                        className={`label ${
                          pristine && !this.insuranceForm.controls.insProvider.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        Insurance Provider
                        <span className="error">
                          {(touched || submitted) && hasError('required') && ' - Required'}
                          {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                        </span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <div>
                <FieldControl
                  name="insPolicy"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input id="insPolicy" className="form-control" type="text" {...handler()} />
                      <label
                        htmlFor="insPolicy"
                        className={`label ${
                          pristine && !this.insuranceForm.controls.insPolicy.value ? '' : 'notEmpty'
                        }`}
                      >
                        Insurance Policy Number
                        <span className="error">
                          {(touched || submitted) && hasError('required') && ' - Required'}
                          {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                        </span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <div>
                <FieldControl
                  name="insStartDate"
                  render={({ touched, hasError, pristine }) => (
                    <div className="inputContainer datepicker">
                      <DatePicker
                        id="insStartDate"
                        className="form-control"
                        selected={this.state.insStartDate}
                        onChange={this.handleStartDateChange}
                        popperModifiers={{
                          flip: {
                            enabled: false,
                          },
                          preventOverflow: {
                            enabled: true,
                            escapeWithReference: false,
                          },
                        }}
                      />
                      <label
                        htmlFor="insStartDate"
                        className={`label ${
                          pristine && !this.insuranceForm.controls.insStartDate.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        Insurance Start Date
                        <span className="error">
                          {!submitted && !hasError() && ' - Please include travel days'}
                          {(touched || submitted) && hasError('required') && ' - Required'}
                          {(touched || submitted) &&
                            hasError('invalidDate') &&
                            ' - Needs to start on/before trip date'}
                        </span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <div>
                <FieldControl
                  name="insEndDate"
                  render={({ touched, hasError, pristine }) => (
                    <div className="inputContainer datepicker">
                      <DatePicker
                        id="insEndDate"
                        className="form-control"
                        selected={this.state.insEndDate}
                        onChange={this.handleEndDateChange}
                        minDate={moment()}
                        popperModifiers={{
                          flip: {
                            enabled: false,
                          },
                          preventOverflow: {
                            enabled: true,
                            escapeWithReference: false,
                          },
                        }}
                      />
                      <label
                        htmlFor="insEndDate"
                        className={`label ${
                          pristine && !this.insuranceForm.controls.insEndDate.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        Insurance End Date
                        <span className="error">
                          {!submitted && !hasError() && ' - Please include travel days'}
                          {(touched || submitted) && hasError('required') && ' - Required'}
                          {(touched || submitted) &&
                            hasError('invalidDate') &&
                            ' - Needs to end after trip date'}
                        </span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <p>
                <span className="round-icon small">3</span> Upload a copy of the confirmation page
                with your policy number, dates of coverage, etc. You can take a screenshot or
                download the PDF confirmation to your computer to upload.
              </p>
              <br />
              {this.state.insuranceDoc && !this.state.insuranceDoc.travelDocumentURL ? (
                <div>
                  <FieldControl
                    name="travelDocument"
                    render={({ touched, hasError }) => (
                      <div className="inputContainer">
                        <input
                          className="form-control"
                          id="initial-ins-upload-field"
                          type="file"
                          onChange={this.onImageSelect}
                        />
                        <label htmlFor="travelDocument" className="label notEmpty">
                          Insurance Document Photo
                          <span className="error">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
              ) : null}
            </form>
          )}
        />
        {this.state.insuranceDoc && this.state.insuranceDoc.travelDocumentURL ? (
          <div>
            <p>
              Insurance Photo Uploaded!{' '}
              <button
                className="inline btn-plain-text"
                onClick={() => this.openModal('insurancePreviewModal')}
              >
                &#8226; Preview
              </button>
              <span className="upload-btn-wrapper">
                &#8226; {!this.state.travelDocument ? 'Update/Add' : 'Update'}
                <input id="update-ins-upload-field" type="file" onChange={this.onImageSelect} />
              </span>
            </p>
            <br />
          </div>
        ) : null}
        <button
          onClick={e => this.handleSubmit(e)}
          className={`${this.state.loadingBtn ? 'btn-text-hide' : ''}`}
          type="submit"
          disabled={this.state.loadingBtn}
        >
          Submit
          <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
        </button>
        <Modal
          isOpen={this.state.activeModal === 'insurancePreviewModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <InsurancePreviewModal previewUrl={this.state.previewUrl} closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

Insurance.propTypes = {
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  mailingCountry: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  setDocumentsAccordionState: PropTypes.func.isRequired,
  insurance: PropTypes.shape({
    insProvider: PropTypes.string,
    insPolicy: PropTypes.string,
    insStartDate: PropTypes.string,
    insEndDate: PropTypes.string,
    travelDocumentURL: PropTypes.string,
  }).isRequired,
};
